import React, { useState } from "react";
import styled from "styled-components";

interface SwitchProps {
  initValue: boolean;
  onToggle: (isChecked: boolean) => void;
}

const Switch: React.FC<SwitchProps> = ({ initValue, onToggle }) => {
  const [isToggled, setIsToggled] = useState(initValue);

  const handleToggle = () => {
    const updatedToggle = !isToggled;
    setIsToggled(updatedToggle);
    onToggle(updatedToggle);
  };

  return (
    <ToggleSwitch>
      <HiddenCheckbox checked={isToggled} onChange={handleToggle} />
      <SwitchSpan checked={isToggled} />
    </ToggleSwitch>
  );
};

const ToggleSwitch = styled.label`
  display: inline-block;
  position: relative;
  width: 50px;
  height: 25px;
`;

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

const SwitchSpan = styled.span<{ checked: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(theme) => (theme.checked ? "#00afff" : "#ccc")};
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.2s;

  &::before {
    content: "";
    position: absolute;
    width: 20px;
    height: 20px;
    left: 3px;
    top: 3px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.2s;
    transform: ${(theme) => (theme.checked ? "translateX(25px)" : "translateX(0)")};
  }
`;

export default Switch;
